// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__XkXgj","calendarButtons":"ClockData_calendarButtons__13mw1"};